import { Component, inject, OnInit, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Route } from '../../utils/route';
import { TabsComponent } from '../../components/tabs/tabs.component';
import { MainKpisComponent } from './main-kpis/main-kpis.component';
import { SalesPerformanceTabComponent } from './sales-performance-tab/sales-performance-tab.component';
import { ProductsPerformanceTabComponent } from './products-performance-tab/products-performance-tab.component';
import { ClassesDistributionTabComponent } from './classes-distribution-tab/classes-distribution-tab.component';
import { MarketSamplesTabComponent } from './market-samples-tab/market-samples-tab.component';
import { ProductSamplesTabComponent } from './product-samples-tab/product-samples-tab.component';
import { AccumulativeListTabComponent } from './accumulative-list-tab/accumulative-list-tab.component';

@Component({
  selector: 'app-users',
  imports: [
    TabsComponent,
    MainKpisComponent,
    SalesPerformanceTabComponent,
    ProductsPerformanceTabComponent,
    ClassesDistributionTabComponent,
    MarketSamplesTabComponent,
    ProductSamplesTabComponent,
    AccumulativeListTabComponent,
  ],
  templateUrl: './users.component.html',
  styleUrl: './users.component.scss',
})
export class UsersComponent extends Route implements OnInit {
  private activatedRoute = inject(ActivatedRoute);
  private router = inject(Router);

  defaultTab = signal<string>('');

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.defaultTab.set(params['tab'] || '');
    });
  }

  onTabChange(tab: string): void {
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { tab },
      queryParamsHandling: 'merge',
      replaceUrl: true,
    });
  }
}
